import Slide from "@/components/_Organisms/ProductList/components/Slide";
import { useProducts } from "@/hooks";
import { PreviewViewSettings, StyledTabPanel } from "@/includes";
import { TabContext, TabList } from "@mui/lab";
import { Box, Stack, Tab, useTheme } from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Table from "../Table";
import { TAB_PREVIEW_ENUMS } from "./enums";
import { DisplayPreviewProps } from "./types";

const DisplayPreview = ({
  collectionResult,
  runningCollection,
  loading,
  slot,
  error = "",
}: DisplayPreviewProps) => {
  const { t } = useTranslation();
  const [displayType, setDisplayType] = useState("list");
  const theme = useTheme();

  const [tabValue, setTabValue] = useState<TAB_PREVIEW_ENUMS>(
    TAB_PREVIEW_ENUMS.LIST
  );

  const handleChangeTab = (
    event: React.SyntheticEvent | null,
    newValue: TAB_PREVIEW_ENUMS
  ) => {
    setTabValue(newValue);
  };
  const { getProductsInfos, isGettingProductInfos } = useProducts();
  const [productsToShowWithData, setProductsToShowWithData] = useState<
    Array<Dic<any>>
  >([]);

  useEffect(() => {
    if (!isEmpty(collectionResult)) {
      getProductsInfos(
        collectionResult?.map((pdToShow: Dic<any>) => pdToShow.id)
      ).then((res: Dic<any>) =>
        setProductsToShowWithData(
          res.map((resProduct: Dic<any>) => ({
            ...resProduct,
            ...resProduct.enrichedData,
          }))
        )
      );
    }
  }, [collectionResult]);
  return (
    <Stack>
      <TabContext value={tabValue}>
        <Stack
          direction="row"
          sx={{ width: "100%" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              margin: "0 !important",
            }}
          >
            <TabList
              scrollButtons
              allowScrollButtonsMobile
              TabIndicatorProps={{
                style: {
                  backgroundColor: theme.customPalette.bluePurple.dark,
                },
              }}
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
              sx={{
                "& .MuiButtonBase-root": {
                  alignItems: "end",
                },
              }}
            >
              <Tab
                key={TAB_PREVIEW_ENUMS.LIST}
                label={t("list")}
                value={TAB_PREVIEW_ENUMS.LIST}
                iconPosition="start"
              />
              <Tab
                key={TAB_PREVIEW_ENUMS.TABLE}
                label={t("table")}
                value={TAB_PREVIEW_ENUMS.TABLE}
                iconPosition="start"
              />
            </TabList>
          </Box>
          <Stack direction="row" alignItems="center" spacing={1}>
            {slot}
            {tabValue === TAB_PREVIEW_ENUMS.LIST && (
              <Box>
                <PreviewViewSettings />
              </Box>
            )}
          </Stack>
        </Stack>

        <StyledTabPanel value={TAB_PREVIEW_ENUMS.LIST}>
          <Box sx={{ minHeight: 300 }}>
            <Slide
              isLoading={loading || runningCollection}
              list="run result"
              products={collectionResult}
              error={error}
            />
          </Box>
        </StyledTabPanel>
        <StyledTabPanel value={TAB_PREVIEW_ENUMS.TABLE}>
          <Box sx={{ margin: "auto", minHeight: 300 }}>
            <Box sx={{ maxWidth: "100%", p: 1 }}>
              <Table
                list="run result"
                error={error}
                products={collectionResult}
                productsToShowWithData={productsToShowWithData}
                loading={loading}
                runningCollection={runningCollection}
                isGettingProductInfos={isGettingProductInfos}
                collectionResult={collectionResult}
              />
            </Box>
          </Box>
        </StyledTabPanel>
      </TabContext>
    </Stack>
  );
};

export default DisplayPreview;
